import { render, staticRenderFns } from "./CreateEditInventoryItemModal.vue?vue&type=template&id=d5cf98a6&"
import script from "./CreateEditInventoryItemModal.vue?vue&type=script&lang=js&"
export * from "./CreateEditInventoryItemModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports